export const LOCAL_STORAGE_KEYS = {
  USER: 'userInfo',
  AUTH: 'auth',
  LANGUAGE: 'lang',
  MOBILE_VERIFICATION_TIMESTAMPS: 'mobileVerificationTimestamps',
  COUNTRY: 'countryCode',
} as const;
